<div class="xr-page">
  <header class="xr-page-header">
    <div>
      <h1 class="xr-page-title">{{ 'technicians_page.title' | translate }}</h1>
    </div>
    <div class="technicians-toolbar">
      <app-company-filter></app-company-filter>
      <label class="xr-search technicians-search">
        <i-tabler name="search" class="icon-18 d-flex technicians-search__icon" aria-hidden="true"></i-tabler>
        <span class="xr-sr-only">{{ 'technicians_page.search_label' | translate }}</span>
        <input type="search" [placeholder]="'technicians_page.search_placeholder' | translate" [formControl]="searchControl"/>
      </label>
      @if (user && user.roles && user.roles.id < Roles.OPERATOR_BO) {
        <button type="button" class="xr-btn xr-btn--primary" (click)="addTechnician({})">
          <i-tabler name="plus" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
          {{ 'technicians_page.add' | translate }}
        </button>
      }
    </div>
  </header>

  <div class="technicians-bar">
  <div class="xr-filters technicians-types" role="group" [attr.aria-label]="'technicians_page.type_filter_label' | translate">
    @for (type of typeFilters; track type) {
      <button
        type="button"
        class="xr-filter"
        [class.active]="typeFilter === type"
        [attr.aria-pressed]="typeFilter === type"
        (click)="setTypeFilter(type)"
      >
        {{ (type === 'all' ? 'technicians_page.type_all' : RoleLabelKeys[type]) | translate }}
        <span class="technicians-type-count">{{ countFor(type) }}</span>
      </button>
    }
  </div>
  <div class="xr-filters technicians-view" role="group" [attr.aria-label]="'technicians_page.view_label' | translate">
    <button type="button" class="xr-filter" [class.active]="view === 'cards'" [attr.aria-pressed]="view === 'cards'" (click)="setView('cards')">
      <i-tabler name="layout-grid" class="icon-16 d-flex" aria-hidden="true"></i-tabler> {{ 'technicians_page.view_cards' | translate }}
    </button>
    <button type="button" class="xr-filter" [class.active]="view === 'list'" [attr.aria-pressed]="view === 'list'" (click)="setView('list')">
      <i-tabler name="list" class="icon-16 d-flex" aria-hidden="true"></i-tabler> {{ 'technicians_page.view_list' | translate }}
    </button>
  </div>
  </div>

  @if (searchControl.value && searchControl.value.length < 3) {
    <p class="technicians-hint" aria-live="polite">{{ 'technicians_page.search_hint' | translate }}</p>
  }

  @if (filteredTechnicians.length) {
    @if (view === 'list') {
      <!-- "Elenco": everyone at a glance, one row each -->
      <section class="xr-card technicians-list" [attr.aria-label]="'technicians_page.list_label' | translate">
        <div class="technicians-list__head" aria-hidden="true">
          <span>{{ 'technicians_page.col_name' | translate }}</span>
          <span>{{ 'technicians_page.col_role' | translate }}</span>
          <span>{{ 'technicians_page.company' | translate }}</span>
          <span>{{ 'technicians_page.room' | translate }}</span>
          <span></span>
        </div>
        @for (technician of filteredTechnicians; track technician.id) {
          <app-card-user
            [compact]="true"
            [technician]="technician"
            [assignedRoomName]="assignedRoomNames[technician.id]"
            (technicianDeleted)="loadTechnicians()"
          ></app-card-user>
        }
      </section>
    } @else {
    <section class="xr-grid technicians-grid" [attr.aria-label]="'technicians_page.list_label' | translate">
      @for (technician of filteredTechnicians; track technician.id) {
        <app-card-user
          [technician]="technician"
          [assignedRoomName]="assignedRoomNames[technician.id]"
          (technicianDeleted)="loadTechnicians()"
        ></app-card-user>
      }
    </section>
    }
  } @else if (loaded) {
    <div class="xr-empty">
      {{ (technicians.length ? (typeFilter !== 'all' && !searchControl.value ? 'technicians_page.empty_type' : 'technicians_page.empty_search') : 'technicians_page.empty') | translate }}
    </div>
  }
</div>
